import {css} from '../theme/css'
import {theme} from '../theme/theme'
import {makeStyles} from '../theme/UNSTABLE_makeStyles'

export const classes = {
  root: css`
    color: ${theme.go.schemes.colors.system.Link};
    font-family: inherit;
    text-decoration: none;
    display: flex;
    align-items: center;
  `,
  icon: css`
    display: flex;
    margin-right: ${theme.go.schemes.spacing.units.XS}px;

    & svg {
      width: 20px;
      height: 20px;
    }
  `,
  disabled: css`
    pointer-events: none;
  `,
}

export type ClassKey = keyof typeof classes

export const useClasses = makeStyles(classes)
